const InfoIcon = ({
	size = 'medium',
	...props
}: {
	size?: 'small' | 'medium'
}) => (
	<svg
		{...props}
		width={size === 'small' ? '16' : '24'}
		height={size === 'small' ? '16' : '24'}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM10.908 16.6673C10.8998 16.949 11.126 17.1818 11.4078 17.1818L12.5903 17.1818C12.8723 17.1818 13.0985 16.9488 13.0901 16.6669L12.921 10.9851C12.9129 10.7149 12.6916 10.5 12.4212 10.5L11.5727 10.5C11.3022 10.5 11.0807 10.7151 11.0729 10.9855L10.908 16.6673ZM12.8419 7.21875C12.6066 6.98674 12.3249 6.87074 11.9968 6.87074C11.7846 6.87074 11.5891 6.92377 11.4101 7.02983C11.2311 7.1392 11.087 7.28338 10.9776 7.46236C10.8649 7.64465 10.8069 7.84517 10.8036 8.06392C10.8069 8.38873 10.9279 8.66714 11.1665 8.89915C11.4051 9.13116 11.6819 9.24716 11.9968 9.24716C12.3249 9.24716 12.6066 9.13116 12.8419 8.89915C13.0772 8.66714 13.1932 8.38873 13.1899 8.06392C13.1932 7.7358 13.0772 7.45407 12.8419 7.21875Z"
			fill="currentColor"
		/>
	</svg>
)

export default InfoIcon
